<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des <strong>types d'opérations</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="code">Code Opération</label>
              <select v-model="typeoperation.code" class="form-control" @change="choose_code" disabled>
                <option v-for="option in options_code_operation" v-bind:value="option.value">
                  {{ option.value }}
                </option>
              </select>
            </b-col>
            <b-col md="6">
              <label for="libelle">Entete</label>
              <b-form-select id="sens_operation" :plain="true" :options="options_headers" disabled v-model="typeoperation.entetetypeoperation_id" >
              </b-form-select>
              <!-- <b-form-input type="text" v-model="typeoperation.libelle" placeholder="Libelle : paiement de masse, transfert d'argent"></b-form-input> -->
            </b-col>
          </b-row> 
          <b-row class="form-group">
            <b-col md="6">
              <label for="sens_operation">Sens</label>
              <b-form-select id="sens_operation" :plain="true" :options="options_sens" disabled v-model="typeoperation.sensoperation_libelle" >
              </b-form-select>
             
              <!-- <b-form-input type="text" v-model="typeoperation.sens" placeholder="Sens : Retrait ..."></b-form-input> -->
            </b-col>
            <b-col md="6">
              <label for="commission">Commision(%)</label>
              <!-- <b-form-select id="taxe" :plain="true" :options="options_tax" v-model="typeoperation.commission" >
              </b-form-select> -->
              <b-form-input type="number" min="0" max="50" v-model="typeoperation.commission" placeholder=""></b-form-input> 
            </b-col>
          </b-row>   
          <!--<b-row class="form-group">
            <b-col md="6">
              <label for="taxe">Plafond (Montant)</label>
              <b-form-input type="number" min="1" v-model="typeoperation.plafond" placeholder=""></b-form-input>
              
            </b-col>
            <b-col md="6">
              <label for="commission">Période (En jours)</label>
              <b-form-input type="number" min="1" v-model="typeoperation.periode_plafond"  placeholder=""></b-form-input>
            </b-col>
          </b-row>-->
          <b-row class="form-group">  
            
          </b-row>
          <div slot="footer">
            <span v-if="can('typeoperation-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset"  @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>  
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      options_sens : [],
      options_headers : [],
      options_tax : [],
      options_code_operation : [{value:'PME',text:'PAIEMENT DE MASSE ENVOIE'},{value:'PMR',text:'PAIEMENT DE MASSE RETRAIT'},{value:'TAR',text:'TRANSFERT D\'ARGENT RETRAIT'},{value:'TAE',text:'TRANSFERT D\'ARGENT ENVOIE'}],
      typeoperation:{
        code: '',
        entetetypeoperation_id: '',
        // plafond: '',
        // periode_plafond: '',
        sensoperation_libelle: '',
        commission: '',
        _method: 'PUT',
      },
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      }
    }
  },
  methods:{
    async get_all_typeoperations_headers(){
          await this.$store.dispatch('typeoperation_headers/get_all_typeoperations_headers',this.serverParams).then(()=>{
            return this.operations_headers =  store.getters['typeoperation_headers/rows'];
          })
          //this.sensoperations =  store.getters['agency/rows'];
          this.operations_headers.forEach((element)=>{
              console.log("element ",element)
              this.options_headers.push({
                value:element.id,
                text:element.libelle.toUpperCase()
              })
          })
          this.options_sens = this.options
    },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async put(){    
        //this.sensoperation_libelle= 'envoie', 
        this.response = await this.$store.dispatch('typeoperation/put_typeoperations',this.typeoperation)
        this.showAlert()

    },
    can(perm){
      return store.getters['auth/can'](perm)
    },
    async get_all_sensoperations(){
          await this.$store.dispatch('typeoperation/get_all_sensoperations').then(()=>{
            return this.sensoperations =  store.getters['typeoperation/sens'];
          })
          //this.sensoperations =  store.getters['agency/rows'];
          this.sensoperations.forEach((element)=>{
              this.options.push({
                value:element.libelle,
                text:element.libelle.toUpperCase()
              })
          })
          this.options_sens = this.options
    },
    async get_all_tax(){
          await this.$store.dispatch('tax/get_all_taxes',this.serverParams).then(()=>{
            return this.tax =  store.getters['tax/rows'];
          })
          //this.sensoperations =  store.getters['agency/rows'];
          this.tax.forEach((element)=>{      
              this.options_tax.push({
                value:element.valeur,
                text:element.libelle.toUpperCase()
              })
          })              
    },
    async get_all_grilletarifaires(){
      await this.$store.dispatch('grilletarifaire/get_all_grilletarifaires',this.serverParams).then(()=>{
        return this.grille =  store.getters['grilletarifaire/rows'];
      })
      this.grille.forEach((element)=>{
          this.options_grille.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    
    choose_code(){
      let options_code_operation=[]
      if (this.typeoperation.code.toUpperCase()==="PME"){
        this.typeoperation.sensoperation_libelle="envoi"
        this.typeoperation.entetetypeoperation_id=2
        let sens = this.options.find(function(v) {
          return v.text.toUpperCase()=="ENVOI"
        })
        this.options_sens=[sens]
      }else if (this.typeoperation.code.toUpperCase()==="PMR"){
        this.typeoperation.sensoperation_libelle="retrait"
        this.typeoperation.entetetypeoperation_id=2
        let sens = this.options.find(function(v) {
          return v.text.toUpperCase()=="RETRAIT"
        })
        this.options_sens=[sens]
      }else if (this.typeoperation.code.toUpperCase()==="TAE"){
        this.typeoperation.sensoperation_libelle="envoi"
        this.typeoperation.entetetypeoperation_id=1
        let sens = this.options.find(function(v) {
          return v.text.toUpperCase()=="ENVOI"
        })
        this.options_sens=[sens]
      }else if (this.typeoperation.code.toUpperCase()==="TAR"){
        this.typeoperation.sensoperation_libelle="retrait"
        this.typeoperation.entetetypeoperation_id=1
        let sens = this.options.find(function(v) {
          return v.text.toUpperCase()=="RETRAIT"
        })
        this.options_sens=[sens]
      }
    },
    can(perm){
      return store.getters['auth/can'](perm)
    },
    async display_type_operation(){
        let response = await this.$store.dispatch('typeoperation/show_typeoperations',this.$route.params.id)
        console.log("response ",response)
        this.typeoperation.code=response.code
        this.typeoperation.libelle= response.libelle
        this.typeoperation.sensoperation_libelle= response.sensoperation_libelle
        this.typeoperation.entetetypeoperation_id= response.entetetypeoperation_id
        
        this.typeoperation.commission= response.commission

        // this.typeoperation.plafond=response.plafond
        // this.typeoperation.periode_plafond=response.periode_plafond
    }
  },
  mounted(){
    //this.get_all_tax()
    this.get_all_sensoperations()
    this.get_all_typeoperations_headers()
    this.display_type_operation()
  }
}
</script>
